/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'eu-west-1',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_hg2Guvn6a',
  aws_user_pools_web_client_id: '23nt5cghippbf7dt6c9pbql96f',
  oauth: {
    domain: 'wettermanufaktur.auth.eu-west-1.amazoncognito.com',
    scope: ['email', 'openid', 'profile'],
    redirectSignIn:
      'http://localhost:4200/callback,http://localhost:4201/callback',
    redirectSignOut: 'http://localhost:4200/,http://localhost:4201/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
};

export default awsmobile;
